import * as angular from "angular";
import * as _ from "lodash";
import {TextTemplatePurposeType} from "../text-templates/types/text-template-purpose.type";
import {TextTemplateReceiverType} from "../text-templates/types/text-template-receiver.type";
import TextTemplatesService from "../text-templates/services/text-templates-service.service";
import {$accountFactory} from "./$account.factory";
import {QuickFilterContextService} from "../commons/services/quick-filter-context.service";
import {DeliveriesService} from "../deliveries/services/deliveries-service.service";
import {OrdersService} from "../orders/services/orders-service.service";
import {SubTasksRequestsService} from "../sub-tasks/services/sub-tasks-requests.service";
import {SettingsService} from "../site-preferences/services/settings-service.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {PricePlanBundleRequestsService} from "../price-plan/services/price-plan-bundle-requests.service";
import {PricePlanRequestsService} from "../price-plan/services/price-plan-requests.service";
import {TaskModel} from "../tasks/models/task.model";
import {CommonsService} from "../commons/services/commons-service.service";
import {LocationType} from "../commons/types/location.type";
import {PricePlanBundleService} from "../price-plan/services/price-plan-bundle.service";
import {SplitService} from "../commons/services/split-service.service";
// import {AccountsFacadeService} from "./angular/services/accounts-facade.service";

angular
  .module('bringoz.admin.accounts')
  .config(AccountsStateConfig);

/* @ngInject */
function AccountsStateConfig($stateProvider) {

  $stateProvider

    //Accounts View
    .state('accounts-list-demand', {
      parent: 'bringoz.site',
      url: '/accounts/demand?:isActive',
      controllerAs: 'vm',
      template: '<demand-accounts is-active="vm.isActive"></demand-accounts>',
      controller: function (triBreadcrumbsService, site, $stateParams) {
        this.isActive = !_.isUndefined($stateParams.isActive) ? JSON.parse($stateParams.isActive) : undefined;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Accounts"});
        triBreadcrumbsService.addCrumb({name: "Shippers"});
      }
    })

    .state('accounts-agent-assignments', {
      parent: 'bringoz.site',
      url: '/accounts/agent-assignments?:branchIds&:groupIds&:tags&:segment&:agentIds&:query',
      controllerAs: 'vm',
      template: '<agent-account-assignment-manager ' +
        'branch-ids="vm.branchIds" ' +
        'group-ids="vm.groupIds" ' +
        'tags="vm.tags" ' +
        'segment="vm.segment" ' +
        'agent-ids="vm.agentIds">' +
        '</agent-account-assignment-manager>',
      controller: function (triBreadcrumbsService, commonsService: CommonsService, $stateParams) {
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds);
        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds);
        this.tags = commonsService.parseArrayStateParam($stateParams.tags);
        const segment = Number($stateParams.segment);
        this.segment = _.isNil($stateParams.segment) || $stateParams.segment === '' || Number.isNaN(segment) ? undefined : segment;
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds);

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Agent Assignment Manager'});
      }
    })

    // Upload Agent Assignments View (restricted / dedicated / preferred)
    .state('accounts-agent-assignments-upload', {
      parent: 'bringoz.site',
      url: '/accounts/agent-assignments-upload?:type',
      controllerAs: 'vm',
      template: '<agent-assignments-import-view permission permission-only="vm.importType.permissions" ' +
        'import-type-id="vm.importTypeId"></agent-assignments-import-view>',
      controller: function (triBreadcrumbsService, $state, $stateParams, accountsConstants, IAMPermissions) {
        const importType = _.find(accountsConstants.agentAssignmentImportTypes,
          (type: any) => type.id === $stateParams.type);
        const hasImportPermission = importType && _.some(importType.permissions,
          (permission: string) => IAMPermissions.hasPermission(permission));

        if (!hasImportPermission) {
          $state.go('accounts-agent-assignments');
          return;
        }

        this.importType = importType;
        this.importTypeId = importType.id;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: importType.label});
        triBreadcrumbsService.addCrumb({name: 'Agent Assignment Manager', state: 'accounts-agent-assignments'});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
      }
    })

    //Upload Accounts View
    .state('accounts-upload', {
      parent: 'bringoz.site',
      url: '/accounts-upload',
      template: '<upload-accounts-view></upload-accounts-view>',
      controller: function (triBreadcrumbsService, site) {

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Upload Accounts"});
        triBreadcrumbsService.addCrumb({name: "Shippers"});
      }
    })

    // Visit Configurations
    .state('accounts-visit-configurations', {
      parent: 'bringoz.site',
      url: '/accounts/visit-configurations?:from&:to&:ids&:accountIds&:serviceTypes&:programTypes&:branchIds',
      template: '<visit-configurations-view ' +
        'from="vm.from" ' +
        'to="vm.to" ' +
        'ids="vm.ids" ' +
        'account-ids="vm.accountIds" ' +
        'service-types="vm.serviceTypes" ' +
        'program-types="vm.programTypes" ' +
        'branch-ids="vm.branchIds" ' +
        'date-range-template-type="vm.dateRangeTemplateType" ' +
        'account="vm.account"></visit-configurations-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams, commonsService, site) {
        this.from = $stateParams.from ? parseInt($stateParams.from) : undefined;
        this.to = $stateParams.to ? parseInt($stateParams.to) : undefined;
        this.ids = $stateParams.ids;
        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType;
        this.serviceTypes = $stateParams.serviceTypes;
        this.programTypes = commonsService.parseArrayStateParam($stateParams.programTypes);
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds);
        this.accountIds = commonsService.parseArrayStateParam($stateParams.accountIds);

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Projection Templates'});
        triBreadcrumbsService.addCrumb({name: "Automations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Account View
    .state('accounts-detail-demand', {
      parent: 'bringoz.site',
      url: '/accounts/demand/:id',
      abstract: true,
      controllerAs: 'vm',
      template: '<shipper-account account-id="vm.accountId"></shipper-account-detailed-view>',
      controller: function ($log, $scope, triBreadcrumbsService, accountId) {
        this.accountId = accountId;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
      resolve: {
        accountId: ($stateParams, site) => {
          return $stateParams.id;
        },
        account: function ($account: $accountFactory, $stateParams, site) {
          return $account($stateParams.id).$instantGet();
        },
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        }
      }
    })

    // Account / Account Info
    .state('accounts-detail-demand.info', {
      url: '',
      abstract: true,
      template: '<shipper-account-info account="$ctrl.account"></shipper-account-info>'
    })

    // Account / Account Info / Preferences
    .state('accounts-detail-demand.info.preferences', {
      url: '/preferences',
      controllerAs: 'vm',
      pageTrack: '/account/demand/info/preferences',
      template: '<shipper-account-preferences account="$ctrl.account" meta-data="vm.metaData"></shipper-account-preferences>',
      controller: function (account, triBreadcrumbsService, splitService) {

        this.metaData = splitService.getAccountMetadataSettings();

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Preferences'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
    })

    // Account / Account Info / Dispatch
    .state('accounts-detail-demand.info.dispatching', {
      url: '/dispatching',
      pageTrack: '/account/demand/info/dispatching',
      template: '<shipper-account-dispatching account="$ctrl.account"></shipper-account-dispatching>',
      controller: function (account, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Dispatching'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
    })

    // Account / Account Info / Branches
    .state('accounts-detail-demand.info.branches', {
      url: '/branches',
      pageTrack: '/account/demand/info/branches',
      controllerAs: 'vm',
      template: '<shipper-account-branches ng-if="$ctrl.account" account="$ctrl.account" '
        + 'branch-ids="vm.branchIds"></shipper-account-branches>',
      controller: function (account, triBreadcrumbsService) {

        this.branchIds = account.branchIds;


        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branches'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
    })

    // Account / Account Info / Depots
    .state('accounts-detail-demand.info.depots', {
      url: '/depots',
      pageTrack: '/account/demand/info/depots',
      template: '<shipper-account-depots account="$ctrl.account"></shipper-account-depots>',
      controller: function (account, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Depots'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
    })

    // Account / Account Info / Providers
    .state('accounts-detail-demand.info.providers', {
      url: '/providers',
      pageTrack: '/account/demand/info/providers',
      template: '<shipper-account-providers-view account="$ctrl.account"></shipper-account-providers-view>',
      controller: function (account, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Providers'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
    })

    // Account / New Delivery
    .state('accounts-detail-demand.new-delivery', {
      url: '/delivery-new?:serviceId',
      pageTrack: '/account/demand/delivery-new',
      controllerAs: 'vm',
      params: {
        order: null,
        quotes: null,
        accountPurpose: null
      },
      template: '<create-delivery account="$ctrl.account" is-duplicate="vm.isDuplicate" ' +
        'price-plan-bundle="vm.pricePlanBundle" order="vm.order" quotes="vm.quotes" ' +
        'customers="vm.customers" default-program-type="vm.defaultProgramType" default-depot="defaultDepot"></create-delivery>',
      controller: function ($stateParams, deliveriesService: DeliveriesService, account, pricePlanBundle, service, customers,
                            ordersService: OrdersService, defaultPricePlanTypeByServiceType, triBreadcrumbsService, defaultDepot) {
        this.pricePlanBundle = pricePlanBundle;
        this.service = service;
        this.defaultDepot = defaultDepot;

        ///// remove unnecessary fields from duplication /////

        this.order = $stateParams.order;
        this.quotes = $stateParams.quotes;
        this.customers = {Pickup: undefined, Dropoff: undefined};
        this.isDuplicate = !_.isUndefined(service);
        this.defaultProgramType = pricePlanBundle.defaultPricePlanProgramType || _.get(defaultPricePlanTypeByServiceType, 'pricePlanType');
        if (!this.order) {
          this.order = ordersService.getEmptyDeliveryOrder(account, defaultDepot, pricePlanBundle, this.defaultProgramType, service);
        }

        if (this.isDuplicate) {
          const orderCopy = angular.copy(this.order);
          _.forEach(orderCopy.serviceList, (s) => {
            _.forEach(s.taskList, (task: TaskModel) => {
              task.additions = _.filter(task.additions, (addition) => {
                return addition.source === 'OMS'
              })
            })
          })

          this.order = orderCopy;
        }

        let delivery = $stateParams.order ? $stateParams.order.serviceList[0] : service;

        if (delivery) {
          let pickup = deliveriesService.getPickups(delivery)[0];
          let dropoff = deliveriesService.getDropoffs(delivery)[0];

          this.customers = {
            Pickup: _getCustomerByTask(pickup, customers),
            Dropoff: _getCustomerByTask(dropoff, customers)
          };
        }

        function _getCustomerByTask(task, customersList) {
          if (!customersList?.length || task.taskSpec.locationDetails?.locationType !== LocationType.CUSTOMER) {
            return undefined;
          }
          return _.find(customersList, function (c) {
            return c.id === task.taskSpec.locationDetails?.id;
          });
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'New Delivery'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
      resolve: {
        pricePlanBundle: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService, $stateParams, site) {
          return pricePlanBundleRequestsService.getPricePlanBundleByAccountId($stateParams.id);
        },
        defaultPricePlanTypeByServiceType: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService, $stateParams, site) {
          return pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType($stateParams.id, 'Delivery');
        },
        service: function ($stateParams, $delivery, site) {
          return $stateParams.serviceId ? $delivery($stateParams.serviceId).$asyncValue() : undefined;
        },
        defaultDepot: function ($stateParams, $depots, account, service, site) {
          return account.defaultDepotId ? $depots(account.defaultDepotId).$asyncValue() : undefined;
        },
        customers: function ($customers, service, $stateParams) {

          let delivery = $stateParams.order ?
            $stateParams.order.serviceList[0] : service;

          let customerIds = _.chain(_.get(delivery, 'taskList', []))
            .filter(function (task: TaskModel) {
              return (task.taskSpec.locationDetails?.locationType === LocationType.CUSTOMER) && !_.isUndefined(task.taskSpec.locationDetails?.id);
            })
            .map(function (filteredTask) {
              return filteredTask.taskSpec.locationDetails.id;
            })
            .value();

          return $customers().$asyncValues(customerIds);
        }
      }
    })

    // Account / New Field Service
    .state('accounts-detail-demand.new-operation', {
      url: '/new-operation?:serviceId',
      pageTrack: '/account/demand/new-operation',
      controllerAs: 'vm',
      params: {
        order: null,
        quote: null
      },
      template: '<create-operation-view account="$ctrl.account" ' +
        'price-plan-bundle="vm.pricePlanBundle" order="vm.order" quote="vm.quote" ' +
        'default-program-type="vm.defaultProgramType"'
        + 'is-duplicate="vm.isDuplicate"></create-operation-view>',
      controller: function ($stateParams, account, pricePlanBundle, service, defaultDepot, defaultPricePlanTypeByServiceType,
                            ordersService, subTaskTemplates, triBreadcrumbsService) {
        this.pricePlanBundle = pricePlanBundle;
        this.service = service;
        this.order = $stateParams.order;
        this.quote = $stateParams.quote;
        this.isDuplicate = !_.isUndefined(service);
        this.defaultProgramType = pricePlanBundle.defaultPricePlanProgramType || _.get(defaultPricePlanTypeByServiceType, 'pricePlanType');
        if (!this.order) {
          this.order = ordersService.getEmptyOperationOrder(account, defaultDepot, pricePlanBundle, this.defaultProgramType, service, this.isDuplicate);
        }

        if (this.isDuplicate) {
          _.forEach(this.order.serviceList, (service) => {
            _.forEach(service.taskList, (task: TaskModel) => {
              task.additions = _.filter(task.additions, (addition) => {
                return addition.source === 'OMS'
              })
            })
          })
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'New Field Service'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
      resolve: {
        pricePlanBundle: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService, $stateParams, site) {
          return pricePlanBundleRequestsService.getPricePlanBundleByAccountId($stateParams.id);
        },
        defaultPricePlanTypeByServiceType: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService, $stateParams, site) {
          return pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType($stateParams.id, 'Operation');
        },
        service: function ($stateParams, $delivery, site) {
          return $stateParams.serviceId ? $delivery($stateParams.serviceId).$asyncValue() : undefined;
        },
        defaultDepot: function ($stateParams, $depots, account, service, site) {
          return account.defaultDepotId ? $depots(account.defaultDepotId).$asyncValue() : undefined;
        },
        subTaskTemplates: function (subTasksRequestsService: SubTasksRequestsService, site) {
          return subTasksRequestsService.getTemplates(['Operational']);
        }

      }
    })

    // Account / New OMS Order
    .state('accounts-detail-demand.new-oms-order', {
      url: '/new-order?',
      pageTrack: '/account/demand/new-order',
      controllerAs: 'vm',
      template: '<oms-order-create-view account="vm.account"></oms-order-create-view>',
      controller: function (triBreadcrumbsService, site, account, metadataSettings) {

        this.account = account;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'New Service'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
      resolve: {
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        }
      }
    })

    // Account / Active Deliveries
    .state('accounts-detail-demand.active-deliveries', {
      url: '/active-deliveries',
      pageTrack: '/account/demand/active-deliveries',
      template: '<account-delivery-active account="$ctrl.account" is-demand="isDemand"></account-delivery-active>',
      controller: function ($scope, triBreadcrumbsService, account) {

        $scope.isDemand = true;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Active Services'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      }
    })


    // Account / Active Orders
    .state('accounts-detail-demand.active-orders', {
      url: '/active-orders',
      pageTrack: '/account/demand/active-orders',
      template: '<account-active-orders account="$ctrl.account" is-demand="true"></account-active-orders>',
      controller: function ($scope, triBreadcrumbsService, account) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Active Orders'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      }
    })

    // Account / Services History
    .state('accounts-detail-demand.delivery-history', {
      url: '/delivery-history',
      pageTrack: '/account/demand/delivery-history',
      template: '<account-delivery-history account="$ctrl.account" is-demand="isDemand"></account-delivery-history>',
      controller: function ($scope, account, triBreadcrumbsService) {
        $scope.isDemand = true;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Services History'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      }
    })

    // Account / Shipper Logins
    .state('accounts-detail-demand.shippers', {
      url: '/shippers?:isActive',
      pageTrack: '/account/demand/shippers',
      controllerAs: 'vm',
      template: '<account-shippers-view account="$ctrl.account" is-active="vm.isActive" selected-quick-filter-id="vm.selectedQuickFilterId"></account-shippers-view>',
      controller: function (account, triBreadcrumbsService, quickFilterContextService: QuickFilterContextService, $state,
                            viewFilterSettingsService: ViewFilterSettingsService, $stateParams) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.isActive = !_.isUndefined($stateParams.isActive) ? JSON.parse($stateParams.isActive) : quickActiveFilter?.settings.isActive;
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
    })

    // Account / Customers
    .state('accounts-detail-demand.customers', {
      url: '/customers',
      pageTrack: '/account/demand/customers',
      template: '<customers-view account="$ctrl.account"></customers-view>',
      controller: function (account, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
    })

    // Account / Agent Ranking
    .state('accounts-detail-demand.agents', {
      url: '/agents',
      abstract: true,
      template: '<account-agents-config-view account="$ctrl.account"></account-agents-config-view>',
      controller: function (account) {

      },
    })

    // Account / Agent Ranking
    .state('accounts-detail-demand.agents.ranking', {
      url: '/ranking',
      pageTrack: '/account/demand/agent-ranking',
      template: '<agent-ranking-view account="$ctrl.account"></agent-ranking-view>',
      controller: function (account, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Agent Ranking'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
    })

    // Account / Restricted
    .state('accounts-detail-demand.agents.restricted', {
      url: '/restricted',
      pageTrack: '/account/demand/agent-restricted',
      template: '<account-agent-restricted-view account="$ctrl.account"></account-agent-restricted-view>',
      controller: function (account, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Restricted Agents'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
    })

    // Account / Dedicated
    .state('accounts-detail-demand.agents.dedicated', {
      url: '/dedicated',
      pageTrack: '/account/demand/agent-dedicated',
      template: '<account-agent-dedicated-view account="$ctrl.account"></account-agent-dedicated-view>',
      controller: function (account, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Dedicated Agents'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
    })

    // Account / Configuration Profile
    .state('accounts-detail-demand.configuration-profile', {
      url: '/configuration-profile',
      pageTrack: '/account/demand/configuration-profile',
      template: '<configuration-profile-view configuration-profile="configurationProfile" ' +
        'account="$ctrl.account" selected-tab="selectedTab" is-account-profile="true"></configuration-profile-view>',
      controller: function ($scope, triBreadcrumbsService, account, configurationProfile) {

        $scope.configurationProfile = configurationProfile;
        $scope.selectedTab = 'autoAssign';

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Configuration Profile'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
      resolve: {
        configurationProfile: function ($configurationProfiles, account) {
          return _.get(account, 'accountConfigurationProfile') ? _.get(account, 'accountConfigurationProfile') :
            $configurationProfiles(_.get(account, 'configurationProfileId')).$asyncValue();
        }
      }
    })


    // Account / Price Plan
    .state('accounts-detail-demand.programs', {
      abstract: true,
      url: '/programs?:programId?:programType',
      reloadOnSearch: false,
      controllerAs: 'vm',
      template: '<account-price-plan-details-view '
        + 'price-plan-bundle="vm.pricePlanBundle" '
        + 'selected-program-id="vm.selectedProgramId" '
        + 'account-id="vm.accountId" '
        + 'program-types="vm.programTypes"></account-price-plan-details-view>',
      controller: function (account, pricePlanBundle, servicesProgramTypes, triBreadcrumbsService, $stateParams, $state) {
        this.pricePlanBundle = pricePlanBundle;
        this.accountId = $stateParams.id;
        this.programTypes = _.filter(pricePlanBundle.entryList, 'enabled');

        this.selectedProgram = _.find(this.programTypes, (p) => {
          if ($stateParams.programId) {
            return p.id === $stateParams.programId;
          } else if ($stateParams.programType) {
            return p.type === $stateParams.programType
          }
        });
        if (this.selectedProgram) {
          this.selectedProgramId = this.selectedProgram.id;
        } else if (pricePlanBundle.defaultPricePlanProgramType && !!this.programTypes.length) {
          const selectedProgram = _.find(this.programTypes, p => {
            return p.type === pricePlanBundle.defaultPricePlanProgramType;
          });
          this.selectedProgramId = selectedProgram?.id || this.programTypes[0].id;
        } else if (Object.keys(servicesProgramTypes).length) {
          const selectedProgram = _.find(this.programTypes, p => {
            return p.type === servicesProgramTypes.Delivery;
          });
          this.selectedProgramId = !!selectedProgram ? selectedProgram.id : _.get(this.programTypes, '[0].id');
        } else {
          this.selectedProgramId = _.get(this.programTypes, '[0].id');
        }


        if (!$stateParams.programId && this.selectedProgramId) {
          $state.go('.', {programId: this.selectedProgramId}, {reload: false, location: 'replace'});
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Programs'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
      resolve: {
        pricePlanBundle: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService, $stateParams, site) {
          return pricePlanBundleRequestsService.getPricePlanBundleByAccountId($stateParams.id);
        },
        servicesProgramTypes: function (site, pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
          return pricePlanBundleRequestsService.getSiteServicesProgramType();
        }
      }
    })
    .state('accounts-detail-demand.programs.service', {
      url: '/plan',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-pricing-method-view flex program-id="vm.programId" program-setting="vm.programSetting" ' +
            'account-id="vm.accountId"></program-pricing-method-view>',
          controllerAs: 'vm',
          controller: function (site, $stateParams, pricePlanBundle, servicesProgramTypes) {
            if (!_.isUndefined($stateParams.programId)) {
              this.programId = $stateParams.programId;
            } else if (Object.keys(servicesProgramTypes).length) {
              const program = _.find(pricePlanBundle.entryList, p => {
                return p.type === servicesProgramTypes.Delivery;
              });
              this.programId = !!program ? program.id : _.find(pricePlanBundle.entryList, (p) => p.enabled)?.id;
            } else {
              this.programId = _.find(pricePlanBundle.entryList, (p) => {
                return p.enabled;
              })?.id
            }
            const programEntry = _.find(pricePlanBundle.entryList, (p) => {
              return p.id === this.programId
            })
            this.programSetting = programEntry?.programSetting;
            this.accountId = $stateParams.id;
          },
          resolve: {
            servicesProgramTypes: function (site, pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
              return pricePlanBundleRequestsService.getSiteServicesProgramType();
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.price', {
      url: '/pricing',
      pageTrack: '/account/demand/programs/pricing',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-pricing-view flex program="vm.program" groups="vm.groups" account-id="vm.accountId" program-id="vm.programId"></price-plan-pricing-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Pricing', 'Wait', 'Late', 'Accessorials', 'SpotDimensions'];
            this.program = program;
            this.accountId = $stateParams.id;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['Pricing', 'Wait', 'Late', 'Accessorials', 'SpotDimensions'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups, $stateParams.id)
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.quantity', {
      url: '/quantity',
      pageTrack: '/account/demand/programs/quantity',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-quantity-view flex program="vm.program" groups="vm.groups" account-id="vm.accountId" program-id="vm.programId"></program-quantity-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['QuantityDiscount'];
            this.program = program;
            this.accountId = $stateParams.id;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['QuantityDiscount'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups, $stateParams.id)
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.vehicleCharge', {
      url: '/vehicle-charge',
      pageTrack: '/account/demand/programs/vehicle-charge',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-vehicle-charge-view flex program="vm.program" groups="vm.groups" account-id="vm.accountId" program-id="vm.programId"></price-plan-vehicle-charge-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams, splitService: SplitService) {
            this.groups = splitService.getUseLegacyVehicleType() ? ['VehicleFactor'] : ['VehicleTypeFactor'];
            this.program = program;
            this.accountId = $stateParams.id;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams, splitService: SplitService) {
              let groups = splitService.getUseLegacyVehicleType() ? ['VehicleFactor'] : ['VehicleTypeFactor'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups, $stateParams.id)
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.packageSize', {
      url: '/package-size',
      pageTrack: '/account/demand/programs/package-size',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-package-size-view flex '
            + 'program="vm.program" '
            + 'groups="vm.groups" '
            + 'account-id="vm.accountId" '
            + 'program-id="vm.programId" '
            + 'label-options="vm.labels"></price-plan-package-size-view>',
          controllerAs: 'vm',
          controller: function (program, labels, $stateParams) {
            this.groups = ['PackageSize'];
            this.program = program;
            this.accountId = $stateParams.id;
            this.programId = $stateParams.programId;
            this.labels = labels;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['PackageSize'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups, $stateParams.id)
            },
            labels: function (labelsRequestsService) {
              return labelsRequestsService.getAll();
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.pod', {
      url: '/pod',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-pod-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'account-id="vm.accountId" '
            + 'program-id="vm.programId"></program-pod-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['PickupPod', 'DropoffPod', 'OmsPickupPod', 'OmsDropoffPod'];
            this.program = program;
            this.accountId = $stateParams.id;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['PickupPod', 'DropoffPod', 'OmsPickupPod', 'OmsDropoffPod'];
              // let groups = ['PickupPod', 'DropoffPod'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups,
                $stateParams.id
              );
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.additions', {
      url: '/additions',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-additions-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'account-id="vm.accountId" '
            + 'program-id="vm.programId" '
            + 'site-additions="vm.siteAdditions"></program-additions-view>',
          controllerAs: 'vm',
          controller: function (program, siteAdditions, $stateParams) {
            this.groups = ['Addition'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.accountId = $stateParams.id;
            this.siteAdditions = siteAdditions;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['Addition'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups,
                $stateParams.id
              );
            },
            siteAdditions: function (pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
              return pricePlanBundleRequestsService.getSiteAdditions();
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.sub-tasks', {
      url: '/sub-tasks',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-sub-tasks-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'account-id="vm.accountId" '
            + 'program-id="vm.programId"></program-sub-tasks-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['SubTasks'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.accountId = $stateParams.id;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['SubTasks'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups,
                $stateParams.id
              );
            }
          }
        }
      }
    })

    .state('accounts-detail-demand.programs.agent-validations', {
      url: '/agent-validations',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-agent-validations-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" site-service-validations="vm.siteServiceValidations" account-id="vm.accountId"></program-agent-validations-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams, siteServiceValidations) {
            this.groups = ['ServiceValidation'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.accountId = $stateParams.id;
            this.siteServiceValidations = siteServiceValidations;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['ServiceValidation'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups,
                $stateParams.id
              );
            },
            siteServiceValidations: function (pricePlanBundleService: PricePlanBundleService) {
              return pricePlanBundleService.getServiceValidations()
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.skills', {
      url: '/skills',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-skills-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'program-id="vm.programId" '
            + 'account-id="vm.accountId"></program-skills-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Skills'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.accountId = $stateParams.id;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['Skills'];
              return pricePlanRequestsService.getPricePlanPreferences(
                $stateParams.programId,
                groups,
                $stateParams.id
              );
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.service-time', {
      url: '/service-time',
      views: {
        'pricePlanDetailsSub': {
          template: '<program-service-time-view flex program="vm.program" '
            + 'groups="vm.groups" '
            + 'account-id="vm.accountId" '
            + 'program-id="vm.programId" is-show-field-service-card="true" is-show-allowed-waiting-card="true"></program-service-time-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['Additional'];
            this.program = program;
            this.programId = $stateParams.programId;
            this.accountId = $stateParams.id;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['Additional'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups, $stateParams.id)
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.scheduling', {
      url: '/urgency-charge',
      pageTrack: '/account/demand/programs/urgency-charge',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-urgency-charge-view flex program="vm.program" groups="vm.groups" account-id="vm.accountId" program-id="vm.programId"></price-plan-urgency-charge-view>',
          controllerAs: 'vm',
          controller: function (program, $stateParams) {
            this.groups = ['UrgencySwitch', 'DynamicQuote', 'TimeSlot', 'UrgencyCharge', 'SchedulingPriority', 'DeliveryDaysIndication'];
            this.program = program;
            this.accountId = $stateParams.id;
            this.programId = $stateParams.programId;
          },
          resolve: {
            program: function (pricePlanRequestsService: PricePlanRequestsService, $stateParams) {
              let groups = ['UrgencySwitch', 'DynamicQuote', 'TimeSlot', 'UrgencyCharge', 'SchedulingPriority', 'DeliveryDaysIndication'];
              return pricePlanRequestsService.getPricePlanPreferences($stateParams.programId, groups, $stateParams.id)
            }
          }
        }
      }
    })
    .state('accounts-detail-demand.programs.calendar', {
      url: '/calendar',
      pageTrack: '/account/demand/programs/calendar',
      views: {
        'pricePlanDetailsSub': {
          template: '<price-plan-calendar program-id="vm.programId"></price-plan-calendar>',
          controllerAs: 'vm',
          controller: function ($stateParams) {
            this.programId = $stateParams.programId
          }
        }
      }
    })

    // Account / Visit Configurations
    .state('accounts-detail-demand.visit-configurations', {
      url: '/visit-configurations?:from&:to&:ids&:serviceTypes&:programTypes&:branchIds',
      pageTrack: '/account/demand/visit-configurations',
      template: '<visit-configurations-view ' +
        'from="vm.from" ' +
        'to="vm.to" ' +
        'ids="vm.ids" ' +
        'service-types="vm.serviceTypes" ' +
        'program-types="vm.programTypes" ' +
        'branch-ids="vm.branchIds" ' +
        'date-range-template-type="vm.dateRangeTemplateType" ' +
        'account="vm.account"></visit-configurations-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, account, $stateParams, commonsService, site) {
        this.from = $stateParams.from ? parseInt($stateParams.from) : undefined;
        this.to = $stateParams.to ? parseInt($stateParams.to) : undefined;
        this.ids = $stateParams.ids;
        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType;
        this.serviceTypes = $stateParams.serviceTypes;
        this.programTypes = commonsService.parseArrayStateParam($stateParams.programTypes);
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds);
        this.account = account;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Projection Templates'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      }
    })

    // Account / Recurring Services
    .state('accounts-detail-demand.recurring-services', {
      url: '/recurring-services',
      pageTrack: '/account/demand/recurring-services',
      template: '<recurring-services-view account-id="vm.accountId" services="vm.services" branch-ids="vm.branchIds"></recurring-services-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, account, site) {
        this.branchIds = account.branchIds;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Recurring Services'});
        triBreadcrumbsService.addCrumb({name: 'Administration'});

      }
    })

    // Account / Billing
    .state('accounts-detail-demand.billing', {
      url: '/billing?:from&:to&:packagesIds&:billingOrderStatus&:invoiceStatuses&:tagNames&:isConsolidated&:hasPrice&:dateRangeTemplateType',
      pageTrack: '/account/demand/billing',
      template: '<billing-orders-view  billing-account-id="vm.billingAccountId" preferences="vm.preferences" ' +
        'from="vm.from" to="vm.to" account-ids="vm.accountIds" packages-ids="vm.packagesIds" billing-order-status="vm.billingOrderStatus" invoice-statuses="vm.invoiceStatuses" tag-names="vm.tagNames" ' +
        'has-price="vm.hasPrice" is-consolidated="vm.isConsolidated" selected-quick-filter-id="vm.selectedQuickFilterId" date-range-template-type="vm.dateRangeTemplateType"></billing-orders-view>',
      controllerAs: 'vm',
      controller: function ($scope, account, preferences, triBreadcrumbsService, commonsService,
                            viewFilterSettingsService, $state, $stateParams, dateRangeTimeFiltersService) {

        this.billingAccountId = account.billingAccountId;

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType || viewFilterSettingsService.getDateRangeTemplateType();
        this.from;
        this.to;

        if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        }

        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.packagesIds = commonsService.parseArrayStateParam($stateParams.packagesIds) || quickActiveFilter?.settings.packagesIds || viewFilterSettingsService.getPackagesIds() || [];
        this.billingOrderStatus = $stateParams.billingOrderStatus || quickActiveFilter?.settings.billingOrderStatus || viewFilterSettingsService.getBillingOrderStatus() || undefined;
        this.invoiceStatuses = commonsService.parseArrayStateParam($stateParams.invoiceStatuses) || quickActiveFilter?.settings.invoiceStatuses || viewFilterSettingsService.getBillingOrderInvoiceStatuses() || [];
        this.tagNames = commonsService.parseArrayStateParam($stateParams.tagNames) || quickActiveFilter?.settings.tagNames || viewFilterSettingsService.getTags() || [];
        this.isConsolidated = typeof $stateParams.isConsolidated === "boolean" ? JSON.parse($stateParams.isConsolidated) : (typeof quickActiveFilter?.settings.isConsolidated === "boolean" ? quickActiveFilter?.settings.isConsolidated : viewFilterSettingsService.getIsConsolidated());
        this.hasPrice = typeof $stateParams.hasPrice === "boolean" ? JSON.parse($stateParams.hasPrice) : (typeof quickActiveFilter?.settings.hasPrice === "boolean" ? quickActiveFilter?.settings.hasPrice : viewFilterSettingsService.getHasPrice());
        this.preferences = preferences;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Billing'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
      resolve: {
        preferences: function (billingAccountsRequests, account, site) {
          return billingAccountsRequests.getPreferences(account.billingAccountId);
        }
      }
    })

    // Account / Payment Methods
    .state('accounts-detail-demand.payment-methods', {
      url: '/payment-methods',
      pageTrack: '/account/demand/payment-methods',
      template: '<payment-methods billing-account="billingAccount"></payment-methods>',
      controller: function ($scope, account, triBreadcrumbsService, $billingAccounts, billingAccount) {
        $scope.isDemand = true;
        $scope.billingAccount = billingAccount;
        $billingAccounts(billingAccount.id).$bind($scope, 'billingAccount');

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Payment Methods'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      },
      resolve: {
        billingAccount: function ($billingAccounts, account) {
          return $billingAccounts(account.billingAccountId).$instantGet();
        }
      }
    })


    // **************
    // Notifications
    // **************

    // *********************
    // Notifications - Email
    // *********************

    .state('accounts-detail-demand.email', {
      url: '/email',
      abstract: true,
      template: '<notifications-configuration></notifications-configuration>'
    })

    .state('accounts-detail-demand.email.recipient', {
      url: '/recipient',
      pageTrack: '/account/demand/notifications/email/recipient',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.RECIPIENT;
        this.purpose = TextTemplatePurposeType.Email;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Recipient'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.RECIPIENT, TextTemplatePurposeType.Email, account.id);
        }
      }
    })
    .state('accounts-detail-demand.email.agent', {
      url: '/agent',
      pageTrack: '/account/demand/notifications/email/agent',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.AGENT;
        this.purpose = TextTemplatePurposeType.Email;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Agent'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.AGENT, TextTemplatePurposeType.Email, account.id);
        }
      }
    })
    .state('accounts-detail-demand.email.sender', {
      url: '/sender',
      pageTrack: '/account/demand/notifications/email/sender',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.SENDER;
        this.purpose = TextTemplatePurposeType.Email;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Sender'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.SENDER, TextTemplatePurposeType.Email, account.id);
        }
      }
    })
    .state('accounts-detail-demand.email.issuer', {
      url: '/issuer',
      pageTrack: '/account/demand/notifications/sms/issuer',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.ISSUER;
        this.purpose = TextTemplatePurposeType.Email;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Issuer'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ISSUER, TextTemplatePurposeType.Email, account.id);
        }
      }
    })
    .state('accounts-detail-demand.email.admin', {
      url: '/admin',
      pageTrack: '/account/demand/notifications/email/admin',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.ADMIN;
        this.purpose = TextTemplatePurposeType.Email;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Admin'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ADMIN, TextTemplatePurposeType.Email, account.id);
        }
      }
    })
    .state('accounts-detail-demand.email.branch', {
      url: '/branch',
      pageTrack: '/account/demand/notifications/email/branch',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.BRANCH_CONTACTS;
        this.purpose = TextTemplatePurposeType.Email;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.BRANCH_CONTACTS, TextTemplatePurposeType.Email, account.id);
        }
      }
    })
    .state('accounts-detail-demand.email.team', {
      url: '/branch',
      pageTrack: '/account/demand/notifications/email/team',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.TEAM_CONTACTS;
        this.purpose = TextTemplatePurposeType.Email;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.TEAM_CONTACTS, TextTemplatePurposeType.Email, account.id);
        }
      }
    })
    .state('accounts-detail-demand.email.operation-contacts', {
      url: '/operation-contacts',
      pageTrack: '/account/demand/notifications/email/operation-contacts',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.OPERATIONAL_CONTACTS;
        this.purpose = TextTemplatePurposeType.Email;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'Email'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, account, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.OPERATIONAL_CONTACTS, TextTemplatePurposeType.Email, account.id);
        }
      }
    })


    // *********************
    // Notifications - SMS
    // *********************

    .state('accounts-detail-demand.sms', {
      url: '/sms',
      abstract: true,
      template: '<notifications-configuration></notifications-configuration>'
    })

    .state('accounts-detail-demand.sms.recipient', {
      url: '/recipient',
      pageTrack: '/account/demand/notifications/sms/recipient',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.RECIPIENT;
        this.purpose = TextTemplatePurposeType.Sms;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Recipient'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.RECIPIENT, TextTemplatePurposeType.Sms, account.id);
        }
      }
    })
    .state('accounts-detail-demand.sms.agent', {
      url: '/agent',
      pageTrack: '/account/demand/notifications/sms/agent',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.AGENT;
        this.purpose = TextTemplatePurposeType.Sms;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Agent'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.AGENT, TextTemplatePurposeType.Sms, account.id);
        }
      }
    })
    .state('accounts-detail-demand.sms.sender', {
      url: '/sender',
      pageTrack: '/account/demand/notifications/sms/sender',
      template: '<notifications-view notifications="vm.notifications" type="vm.type"  purpose="vm.purpose"  account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.SENDER;
        this.purpose = TextTemplatePurposeType.Sms;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Sender'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.SENDER, TextTemplatePurposeType.Sms, account.id);
        }
      }
    })
    .state('accounts-detail-demand.sms.issuer', {
      url: '/issuer',
      pageTrack: '/account/demand/notifications/sms/issuer',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.ISSUER;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Issuer'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ISSUER, TextTemplatePurposeType.Sms, account.id);
        }
      }
    })
    .state('accounts-detail-demand.sms.admin', {
      url: '/admin',
      pageTrack: '/account/demand/notifications/sms/admin',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.ADMIN;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Admin'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ADMIN, TextTemplatePurposeType.Sms, account.id);
        }
      }
    })
    .state('accounts-detail-demand.sms.branch', {
      url: '/branch',
      pageTrack: '/account/demand/notifications/sms/branch',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.BRANCH_CONTACTS;
        this.purpose = TextTemplatePurposeType.Sms;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.BRANCH_CONTACTS, TextTemplatePurposeType.Sms, account.id);
        }
      }
    })
    .state('accounts-detail-demand.sms.team', {
      url: '/branch',
      pageTrack: '/account/demand/notifications/sms/team',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.TEAM_CONTACTS;
        this.purpose = TextTemplatePurposeType.Sms;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: function (textTemplatesService: TextTemplatesService, account, site) {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.TEAM_CONTACTS, TextTemplatePurposeType.Sms, account.id);
        }
      }
    })
    .state('accounts-detail-demand.sms.operation-contacts', {
      url: '/operation-contacts',
      pageTrack: '/account/demand/notifications/sms/operation-contacts',
      template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, notifications, account) {

        this.notifications = notifications;
        this.type = TextTemplateReceiverType.OPERATIONAL_CONTACTS;
        this.purpose = TextTemplatePurposeType.Sms;
        this.accountId = account.id;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Branch'});
        triBreadcrumbsService.addCrumb({name: 'SMS'});
        triBreadcrumbsService.addCrumb({name: 'Notifications'});
      },
      resolve: {
        notifications: (textTemplatesService: TextTemplatesService, account, site) => {
          return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.OPERATIONAL_CONTACTS, TextTemplatePurposeType.Sms, account.id);
        }
      }
    })

  // **********************
  // Notifications - Whatsapp
  // **********************

  .state('accounts-detail-demand.whatsapp', {
    url: '/whatsapp',
    abstract: true,
    template: '<notifications-configuration></notifications-configuration>'
  })

  .state('accounts-detail-demand.whatsapp.recipient', {
    url: '/recipient',
    pageTrack: '/account/demand/notifications/whatsapp/recipient',
    template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
    controllerAs: 'vm',
    controller: function (triBreadcrumbsService, notifications, account) {

      this.notifications = notifications;
      this.type = TextTemplateReceiverType.RECIPIENT;
      this.purpose = TextTemplatePurposeType.WhatsApp;
      this.accountId = account.id;

      // Bread Crumbs
      triBreadcrumbsService.reset();
      triBreadcrumbsService.addCrumb({name: 'Recipient'});
      triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
      triBreadcrumbsService.addCrumb({name: 'Notifications'});
    },
    resolve: {
      notifications: function (textTemplatesService: TextTemplatesService, account, site) {
        return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.RECIPIENT, TextTemplatePurposeType.WhatsApp, account.id);
      }
    }
  })
  .state('accounts-detail-demand.whatsapp.agent', {
    url: '/agent',
    pageTrack: '/account/demand/notifications/whatsapp/agent',
    template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
    controllerAs: 'vm',
    controller: function (triBreadcrumbsService, notifications, account) {

      this.notifications = notifications;
      this.type = TextTemplateReceiverType.AGENT;
      this.purpose = TextTemplatePurposeType.WhatsApp;
      this.accountId = account.id;

      // Bread Crumbs
      triBreadcrumbsService.reset();
      triBreadcrumbsService.addCrumb({name: 'Agent'});
      triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
      triBreadcrumbsService.addCrumb({name: 'Notifications'});
    },
    resolve: {
      notifications: function (textTemplatesService: TextTemplatesService, account, site) {
        return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.AGENT, TextTemplatePurposeType.WhatsApp, account.id);
      }
    }
  })
  .state('accounts-detail-demand.whatsapp.sender', {
    url: '/sender',
    pageTrack: '/account/demand/notifications/whatsapp/sender',
    template: '<notifications-view notifications="vm.notifications" type="vm.type"  purpose="vm.purpose"  account-id="vm.accountId"></notifications-view>',
    controllerAs: 'vm',
    controller: function (triBreadcrumbsService, notifications, account) {

      this.notifications = notifications;
      this.type = TextTemplateReceiverType.SENDER;
      this.purpose = TextTemplatePurposeType.WhatsApp;
      this.accountId = account.id;

      // Bread Crumbs
      triBreadcrumbsService.reset();
      triBreadcrumbsService.addCrumb({name: 'Sender'});
      triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
      triBreadcrumbsService.addCrumb({name: 'Notifications'});
    },
    resolve: {
      notifications: function (textTemplatesService: TextTemplatesService, account, site) {
        return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.SENDER, TextTemplatePurposeType.WhatsApp, account.id);
      }
    }
  })
  .state('accounts-detail-demand.whatsapp.issuer', {
    url: '/issuer',
    pageTrack: '/account/demand/notifications/whatsapp/issuer',
    template: '<notifications-view notifications="vm.notifications" type="vm.type" account-id="vm.accountId"></notifications-view>',
    controllerAs: 'vm',
    controller: function (triBreadcrumbsService, notifications, account) {

      this.notifications = notifications;
      this.type = TextTemplateReceiverType.ISSUER;
      this.accountId = account.id;

      // Bread Crumbs
      triBreadcrumbsService.reset();
      triBreadcrumbsService.addCrumb({name: 'Issuer'});
      triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
      triBreadcrumbsService.addCrumb({name: 'Notifications'});
    },
    resolve: {
      notifications: function (textTemplatesService: TextTemplatesService, account, site) {
        return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ISSUER, TextTemplatePurposeType.WhatsApp, account.id);
      }
    }
  })
  .state('accounts-detail-demand.whatsapp.admin', {
    url: '/admin',
    pageTrack: '/account/demand/notifications/whatsapp/admin',
    template: '<notifications-view notifications="vm.notifications" type="vm.type" account-id="vm.accountId"></notifications-view>',
    controllerAs: 'vm',
    controller: function (triBreadcrumbsService, notifications, account) {

      this.notifications = notifications;
      this.type = TextTemplateReceiverType.ADMIN;
      this.accountId = account.id;

      // Bread Crumbs
      triBreadcrumbsService.reset();
      triBreadcrumbsService.addCrumb({name: 'Admin'});
      triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
      triBreadcrumbsService.addCrumb({name: 'Notifications'});
    },
    resolve: {
      notifications: function (textTemplatesService: TextTemplatesService, account, site) {
        return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.ADMIN, TextTemplatePurposeType.WhatsApp, account.id);
      }
    }
  })
  .state('accounts-detail-demand.whatsapp.branch', {
    url: '/branch',
    pageTrack: '/account/demand/notifications/whatsapp/branch',
    template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
    controllerAs: 'vm',
    controller: function (triBreadcrumbsService, notifications, account) {

      this.notifications = notifications;
      this.type = TextTemplateReceiverType.BRANCH_CONTACTS;
      this.purpose = TextTemplatePurposeType.WhatsApp;
      this.accountId = account.id;

      // Bread Crumbs
      triBreadcrumbsService.reset();
      triBreadcrumbsService.addCrumb({name: 'Branch'});
      triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
      triBreadcrumbsService.addCrumb({name: 'Notifications'});
    },
    resolve: {
      notifications: function (textTemplatesService: TextTemplatesService, account, site) {
        return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.BRANCH_CONTACTS, TextTemplatePurposeType.WhatsApp, account.id);
      }
    }
  })
  .state('accounts-detail-demand.whatsapp.team', {
    url: '/team',
    pageTrack: '/account/demand/notifications/whatsapp/team',
    template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
    controllerAs: 'vm',
    controller: function (triBreadcrumbsService, notifications, account) {

      this.notifications = notifications;
      this.type = TextTemplateReceiverType.TEAM_CONTACTS;
      this.purpose = TextTemplatePurposeType.WhatsApp;
      this.accountId = account.id;

      // Bread Crumbs
      triBreadcrumbsService.reset();
      triBreadcrumbsService.addCrumb({name: 'Team'});
      triBreadcrumbsService.addCrumb({name: 'Whatsapp'});
      triBreadcrumbsService.addCrumb({name: 'Notifications'});
    },
    resolve: {
      notifications: function (textTemplatesService: TextTemplatesService, account, site) {
        return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.TEAM_CONTACTS, TextTemplatePurposeType.WhatsApp, account.id);
      }
    }
  })
  .state('accounts-detail-demand.whatsapp.operation-contacts', {
    url: '/operation-contacts',
    pageTrack: '/account/demand/notifications/whatsapp/operation-contacts',
    template: '<notifications-view notifications="vm.notifications" type="vm.type" purpose="vm.purpose" account-id="vm.accountId"></notifications-view>',
    controllerAs: 'vm',
    controller: function (triBreadcrumbsService, notifications, account) {

      this.notifications = notifications;
      this.type = TextTemplateReceiverType.OPERATIONAL_CONTACTS;
      this.purpose = TextTemplatePurposeType.WhatsApp;
      this.accountId = account.id;

      // Bread Crumbs
      triBreadcrumbsService.reset();
      triBreadcrumbsService.addCrumb({name: 'Operational Contacts'});
      triBreadcrumbsService.addCrumb({name: 'Whatsapp '});
      triBreadcrumbsService.addCrumb({name: 'Notifications'});
    },
    resolve: {
      notifications: (textTemplatesService: TextTemplatesService, account, site) => {
        return textTemplatesService.getTemplatesByTypeAndCategory(TextTemplateReceiverType.OPERATIONAL_CONTACTS, TextTemplatePurposeType.WhatsApp, account.id);
      }
    }
  })


  .state('accounts-detail-demand.scheduling-project', {
      url: '/scheduling-project',
      abstract: true,
      template: '<account-scheduling-project></account-scheduling-project>'
    })

    .state('accounts-detail-demand.scheduling-project.configurations', {
      url: '/configurations',
      template: '<scheduling-project-configurations account="vm.account"></scheduling-project-configurations>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, account) {

        this.account = account;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Configurations'});
        triBreadcrumbsService.addCrumb({name: 'Scheduling Project'});
      },
      resolve: {}
    })

    .state('accounts-detail-demand.scheduling-project.visit-configurations', {
      url: '/visit-configurations?:from&:to&:ids&:serviceTypes&:programTypes&:branchIds',
      pageTrack: '/account/demand/scheduling-project/visit-configurations',
      template: '<visit-configurations-view ' +
        'from="vm.from" ' +
        'to="vm.to" ' +
        'ids="vm.ids" ' +
        'service-types="vm.serviceTypes" ' +
        'program-types="vm.programTypes" ' +
        'branch-ids="vm.branchIds" ' +
        'date-range-template-type="vm.dateRangeTemplateType" ' +
        'account="vm.account"></visit-configurations-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, account, $stateParams, commonsService, site) {
        this.from = $stateParams.from ? parseInt($stateParams.from) : undefined;
        this.to = $stateParams.to ? parseInt($stateParams.to) : undefined;
        this.ids = $stateParams.ids;
        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType;
        this.serviceTypes = $stateParams.serviceTypes;
        this.programTypes = commonsService.parseArrayStateParam($stateParams.programTypes);
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds);
        this.account = account;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Projection Templates'});
        triBreadcrumbsService.addCrumb({name: 'Scheduling Project'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      }
    })

    // Account / Inventory Settings
    .state('accounts-detail-demand.inventory-settings', {
      url: '/inventory-settings',
      pageTrack: '/account/demand/inventory-settings',
      controllerAs: 'vm',
      template: '<demand-account-inventory-config-view account="$ctrl.account"></demand-account-inventory-config-view>',
      controller: function (account, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Inventory Settings'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      }
    })

    // Account / Inventory Transactions
    .state('accounts-detail-demand.inventory-transactions', {
      url: '/inventory-transactions',
      pageTrack: '/account/demand/inventory-transactions',
      controllerAs: 'vm',
      template: '<demand-account-inventory-transactions-view account="$ctrl.account"></demand-account-inventory-transactions-view>',
      controller: function (account, triBreadcrumbsService) {
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Inventory Transactions'});
        triBreadcrumbsService.addCrumb({name: account.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Accounts', state: 'accounts-list-demand'});
        triBreadcrumbsService.addCrumb({name: 'Shippers'});
      }
    })
}
